/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { isStringEqual } from '@/data/utils/isStringEqual';

const BSQ_PAGE = 'bsq';

const getPath = (path: string[] | string | undefined) => {
	if (Array.isArray(path) && path.includes(BSQ_PAGE)) {
		return ['buscar'];
	}

	if (path?.includes(BSQ_PAGE)) {
		return ['buscar'];
	}

	return path;
};

export const normalizeStoreTokenPath = ({
	path: _path,
	storeUrlKeyword,
}: {
	path: string[] | string | undefined;
	storeUrlKeyword: string | undefined;
}) => {
	const path = getPath(_path);
	if (storeUrlKeyword && path) {
		const p = [path].flat();
		return p[0] && isStringEqual(p[0], storeUrlKeyword ?? '') ? p.slice(1) : p;
	} else {
		return path;
	}
};
